import { ChartComponent, SeriesCollectionDirective, SeriesDirective, ColumnSeries, Inject, Category, Legend, DataLabel } from "@syncfusion/ej2-react-charts"
import {barCustomSeries, barPrimaryYAxis, barPrimaryXAxis} from '../../data/dummy'
import { useStateContext } from "../../context/ContextProvider"
import {Header} from '../../components'

const Bar = () => {
  const {currentMode} = useStateContext()
  return (
    <div className="m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl drop-shadow-sm">
      <Header category='Bar' title='Olympic Medal Counts - RIO'/>
      <ChartComponent
      id='bar-chart'
      height='420px'
      width='auto'
      primaryXAxis={barPrimaryXAxis}
      primaryYAxis={barPrimaryYAxis}
      chartArea={{border: {width: 0}}}
      tooltip={{enable: true}}
      background={currentMode==='Dark'? '#33373E': '#fff'}
      legendSettings={{ background: 'white' }}
    >
      <Inject services={[ColumnSeries, Legend, DataLabel, Category ]}/>
      <SeriesCollectionDirective>
        {barCustomSeries.map((item, index)=> <SeriesDirective key={index} {...item}/>)}
      </SeriesCollectionDirective>
    </ChartComponent>
    </div>
  )
}

export default Bar